var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCurationStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_2008",
    "data-name": "\\uADF8\\uB8F9 2008",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_849",
    "data-name": "\\uD328\\uC2A4 849",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "curation-status"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_850",
    "data-name": "\\uD328\\uC2A4 850",
    d: "M13,5h8",
    fill: "none",
    stroke: "#2c3e50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_851",
    "data-name": "\\uD328\\uC2A4 851",
    d: "M13,9h5",
    fill: "none",
    stroke: "#2c3e50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_852",
    "data-name": "\\uD328\\uC2A4 852",
    d: "M13,15h8",
    fill: "none",
    stroke: "#2c3e50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_853",
    "data-name": "\\uD328\\uC2A4 853",
    d: "M13,19h5",
    fill: "none",
    stroke: "#2c3e50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6546",
    "data-name": "\\uC0AC\\uAC01\\uD615 6546",
    width: 6,
    height: 6,
    rx: 1,
    transform: "translate(3 4)",
    fill: "none",
    stroke: "#2c3e50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6547",
    "data-name": "\\uC0AC\\uAC01\\uD615 6547",
    width: 6,
    height: 6,
    rx: 1,
    transform: "translate(3 14)",
    fill: "none",
    stroke: "#2c3e50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurationStatus);
export default __webpack_public_path__ + "static/media/icon-curation-status.eaaa332b.svg";
export { ForwardRef as ReactComponent };